export default __webpack_public_path__ + "static/media/yoga-heart.f6e4917c.png";